// main.tsx — entry for the standalone "Calculadora Modelo 130" page (F15b).
//
// LIGHT BY DESIGN (F15a pattern): React + fiscal engine + theme styles and NOTHING else.
// Deliberately absent: Firebase, Sentry, PWA registration, App shell, context providers.
// The build acceptance check greps the emitted calculator bundles for firebase.

import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-hosted fonts (FL5: no CDN hop) — via shared/fonts.css so the font-face CSS lands in
// the calculators' own chunk instead of dragging vendor.js into the page (see fonts.css).
import '../shared/fonts.css';
import '../../index.css';
import { Modelo130Page } from './Modelo130Page';

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Could not find root element to mount to');
}

// createRoot().render() replaces the static no-JS fallback markup inside #root.
ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <Modelo130Page />
    </React.StrictMode>
);
